import React, { useEffect, useRef, Fragment } from "react";
import { Link } from "react-router-dom";

import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import GetStarted from "components/Sections/GetStarted";
import AppNavbar from "components/Navbars/AppNavbar";
import SimpleFooter from "components/Footers/SimpleFooter";

export default function Index(props) {

    const mainEl = useRef(null);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainEl.current.scrollTop = 0;

        document.title = "Club Apps | Pricing to fit any size"
        document.querySelector('meta[name="description"]').setAttribute("content", "Create your first club and you will automatically be placed on our free Club Subscription. Use our platform to build your organization, and when its time we will be here to assist you with more capacity at industry leading rates.");
    }, []);

    return (
        <Fragment>
            <AppNavbar white/>
            <main ref={mainEl}>
                <section>
                    <Container>
                        <Row className="row-grid align-items-center">
                            <Col md="12" className="sub-nav pb-3">
                                <Link className="link text-primary mr-3" to="/overview">
                                    OVERVIEW
                                </Link>
                                <Link className="link text-primary mr-3" to="/features">
                                    FEATURES
                                </Link>
                                <Link className="link text-default" to="/pricing">
                                    PRICING
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section section-xl section-shaped pb-200">
                    <div className="pricing-background-container"/>
                    <Container className="py-lg-md d-flex">
                        <div className="col px-0">
                            <Row>
                                <Col md="6">
                                    <h1 className="display-3">
                                        Pricing
                                    </h1>
                                    <p className="lead">
                                        As a small company, we understand tight budgets. When you create your first club, you will automatically be placed on our free <span className="text-club font-weight-bold">Club</span> Subscription. Use our platform to build your organization, and when its time we will be here to assist you with more capacity at industry leading rates.
                                    </p>
                                    <div className="btn-wrapper">
                                        <Button
                                            className="mb-3 mb-sm-0 mr-2"
                                            color="primary"
                                            href="https://clubapps.org/register"
                                            >
                                            <span className="btn-inner--text">Get Started</span>
                                        </Button>
                                        <Button
                                            className="btn-white mb-3 mb-sm-0"
                                            color="default"
                                            to="/contact/sales"
                                            tag={Link}
                                            >
                                            <span className="btn-inner--text">
                                                Contact Sales
                                            </span>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                    <div className="separator separator-bottom separator-skew">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-secondary"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section bg-secondary">
                    <Container className="pb-5">
                        <Row>
                            <Col lg="4" className="sub-column sub-column-border">
                                <div className="text-center px-2">
                                    <h4 className="text-club mb-1">Club</h4>
                                    <h6 className="heading font-weight-bold text-muted">Subscription</h6>
                                    <p className="lead mb-4">Includes the following:</p>
                                    <p>*Up to <span className="text-club">1000</span> Authorized Users</p>
                                    <p>Personalized Sub-Domain</p>
                                    <p>User Management w/ Import and Export</p>
                                    <p>Groups and Membership Levels</p>
                                    <p>Event and Ticket Management</p>
                                    <p>Invoicing w/ Import and Export</p>
                                    <p>Online Payments</p>
                                    <p>Member Directory</p>
                                    <p>Articles</p>
                                    <p>Documents</p>
                                    <p><span className="text-club">30-Day</span> Analytics</p>
                                    <div className="d-block d-lg-none">
                                        <p className="lead mb-4 text-club font-weight-normal">$0 / Month</p>
                                        <Button href="https://clubapps.org/register" color="club">
                                            <span className="btn-inner--text">Register now</span>
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                            <Col lg="4" className="sub-column sub-column-border">
                                <div className="text-center px-2">
                                    <h4 className="text-organization mb-1">Organization</h4>
                                    <h6 className="heading font-weight-bold text-muted">Subscription</h6>
                                    <p className="lead mb-4">Includes the following:</p>
                                    <p>
                                        *Up to <span className="text-organization">4000</span> Authorized Users
                                    </p>
                                    <p>*Personalized Domain</p>
                                    <p>User Management w/ Import and Export</p>
                                    <p>Groups and Membership Levels</p>
                                    <p>Event and Ticket Management</p>
                                    <p>Invoicing w/ Import and Export</p>
                                    <p>Online Payments</p>
                                    <p>Member Directory</p>
                                    <p>Articles</p>
                                    <p>Documents</p>
                                    <p><span className="text-organization">60-Day</span> Analytics</p>
                                    <p>Proposal System</p>
                                    <p>Email and Text Notifications</p>
                                    <div className="d-block d-lg-none">
                                        <p className="lead mb-4 text-organization font-weight-normal">
                                            $140 / Month
                                        </p>
                                        <Button
                                            color="organization"
                                            to="/contact/sales"
                                            tag={Link}
                                            className="btn"
                                            >
                                            <span className="btn-inner--text">Contact Sales</span>
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                            <Col lg="4" className="sub-column">
                                <div className="text-center px-2">
                                    <h4 className="text-institution mb-1">Institution</h4>
                                    <h6 className="heading font-weight-bold text-muted">Subscription</h6>
                                    <p className="lead mb-4">Includes the following:</p>
                                    <p>
                                        *Up to <span className="text-institution">10000</span> Authorized Users
                                    </p>
                                    <p>*Personalized Domain</p>
                                    <p>User Management w/ Import and Export</p>
                                    <p>Groups and Membership Levels</p>
                                    <p>Event and Ticket Management</p>
                                    <p>Invoicing w/ Import and Export</p>
                                    <p>Online Payments</p>
                                    <p>Member Directory</p>
                                    <p>Articles</p>
                                    <p>Documents</p>
                                    <p><span className="text-institution">180-Day</span> Analytics</p>
                                    <p>Proposal System</p>
                                    <p>Email and Text Notifications</p>
                                    <Card className="shadow shadow-lg--hover">
                                        <CardBody className="py-4 text-center">
                                            <div className="icon icon-shape icon-shape-institution rounded-circle mb-3">
                                                <i className="ni ni-badge" />
                                            </div>
                                            <h6 className="text-institution text-uppercase">
                                                Dedicated Account Management
                                            </h6>
                                            <p className="description mt-3">
                                                Have your administrative duties handled by a dedicated account manager. Receive monthly analytics emails. Find out more below.
                                            </p>
                                            <Button
                                                className="mt-3"
                                                color="institution"
                                                outline
                                                to="/features#dedicated-account-manager"
                                                tag={Link}
                                                >
                                                Learn more
                                            </Button>
                                        </CardBody>
                                    </Card>
                                    <div className="d-block d-lg-none">
                                        <p className="lead mb-4 text-institution font-weight-normal">
                                            $460 / Month
                                        </p>
                                        <Button
                                            className="mt-3"
                                            color="institution"
                                            to="/contact/sales"
                                            tag={Link}
                                            >
                                            <span className="btn-inner--text">Contact Sales</span>
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                            <Col lg="4" className="sub-column sub-column-border d-none d-lg-block">
                                <div className="text-center px-2">
                                    <p className="lead mb-4 text-club font-weight-normal">$0 / Month</p>
                                    <Button href="https://clubapps.org/register" color="club">
                                        <span className="btn-inner--text">Register now</span>
                                    </Button>
                                </div>
                            </Col>
                            <Col lg="4" className="sub-column sub-column-border d-none d-lg-block">
                                <div className="text-center px-2">
                                    <p className="lead mb-4 text-organization font-weight-normal">
                                        $140 / Month
                                    </p>
                                    <Button
                                        color="organization"
                                        to="/contact/sales"
                                        tag={Link}
                                        >
                                        <span className="btn-inner--text">Contact Sales</span>
                                    </Button>
                                </div>
                            </Col>
                            <Col lg="4" className="sub-column d-none d-lg-block">
                                <div className="text-center px-2">
                                    <p className="lead mb-4 text-institution font-weight-normal">
                                        $460 / Month
                                    </p>
                                    <Button
                                        color="institution"
                                        to="/contact/sales"
                                        tag={Link}
                                        >
                                        <span className="btn-inner--text">Contact Sales</span>
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section section-xl">
                    <Container>
                        <Row className="justify-content-center text-center">
                            <Col md="6">
                                <h3 className="display-4">
                                    Not finding a subscription package that fits your needs?
                                </h3>
                                <p className="lead">
                                    We can accomodate clubs over 10,000 with our custom subscription packages for large scale accounts.
                                </p>
                                <Button
                                    color="dark"
                                    to="/contact/sales"
                                    tag={Link}
                                    className="mt-4"
                                    >
                                    <span className="btn-inner--text">Get in Touch</span>
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </main>
            <SimpleFooter />
        </Fragment>
    );
}
